import React from 'react';
import PropTypes from 'prop-types';
import JsonManager from '../managers/JsonManager';
import iconSVGS from '../resources/svg/combined.svg';

const Icon = (props) => {
  const { type, color, bgColor } = props;
  return (
    <div>
      <svg viewBox="0 0 100 100">
        {bgColor ? (
          <circle cx="50" cy="50" r="50" fill={bgColor} />
        ) : (
          <circle cx="50" cy="50" r="50" fill={color} fillOpacity="0.01" />
        )}
        {
          <use
            width="100%"
            height="100%"
            fill={color}
            xlinkHref={iconSVGS + JsonManager.getSVG(type)}
          />
        }
      </svg>
    </div>
  );
};

Icon.propTypes = {
  type: PropTypes.string.isRequired,
};

export const CustomSizeIcon = (props) => {
  const {
    width, height, type, color,
  } = props;
  return (
    <div>
      <svg viewBox={`0 0 ${width} ${height}`}>
        {<use fill={color} xlinkHref={iconSVGS + JsonManager.getSVG(type)} />}
      </svg>
    </div>
  );
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Icon.js